export enum HabitudeECSEnum {
  HABITUDE_ECS_BAINS = 'HABITUDE_ECS_BAINS',
  HABITUDE_ECS_DOUCHES = 'HABITUDE_ECS_DOUCHES',
  HABITUDE_ECS_BAINS_ET_DOUCHES = 'HABITUDE_ECS_BAINS_ET_DOUCHES',
}
